import { Component, EventEmitter, Input, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TopicAnswers } from '@app/_models';
import { CourseService } from '@app/_services/course.service';
import { TopicShareService } from '@app/_services/topic.share.service';
import { Observable, combineLatest } from 'rxjs';
import { SectionComponent } from '../sections/section.component';

@Component({ selector: 'navigation-progress', templateUrl: 'navigation-progress.component.html' })
export class NavigationProgressComponent {

    @Input() sectionsTotal: any;
    @Input() currentSection: any;
    @Input() sectionType: any;
    @Input() theme: any;

    _parent: SectionComponent;
    sectionId: any;
    isValidSection: boolean;
    valid: boolean;
    actions: { (): Observable<void> }[] = [];

    onContinueEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private route: ActivatedRoute, private router: Router, private shareService: TopicShareService, private courseService: CourseService, private viewContainerRef: ViewContainerRef) {
        
        const _injector = this.viewContainerRef.parentInjector;
        this._parent = _injector.get<SectionComponent>(SectionComponent);  
       
        this.isValidSection = true;
        this.shareService.emitter.subscribe((isValidSection: boolean) => {
            this.isValidSection = isValidSection;
        });
    }

    ngOnInit() {

        this.route.paramMap.subscribe(params => {
            this.sectionId = params.get('id');
        });
    }

    onContinue() {

        let actionPromises = [];

        if (this.actions && this.actions.length > 0) {
            for (let i = 0; i < this.actions.length; i++) {
                actionPromises.push(this.actions[i]());
            }
        }

        this.onContinueEvent.emit();
    }

    onGoBack() {
        this.courseService.getPreviousSection(this.sectionId).subscribe((previousSectionResponse: any) => {

            if (previousSectionResponse) {

                this._parent.sectionType = undefined;

                //get prev section
                var previousSectionId = previousSectionResponse.previousSectionId;

                //redirect
                this.router.navigate(['/course-section', previousSectionId.toString()]);
            }

        });
    }


    
    
}